<template>
  <div class="workflowColumn">
    <section class="workflowBranch">
      <div v-if="!previewMode" class="workflowBranchBtn" @click="addBranch">
        <i class="el-icon-circle-plus"></i>
      </div>
      <div v-else class="fill-Empty"></div>
      <div
        v-for="(branch, idx) in branchInfo.children"
        :key="idx"
        :class="['branchItem', isLastBranch(idx) ? 'last-branch' : '']"
      >
        <div v-if="idx == 0" class="clearLeftBorder"></div>
        <div v-if="isLastBranch(idx)" class="clearRightBorder"></div>
        <section class="workflowBox">
          <div class="workflowItem" @click="setWorkFlow(idx)">
            <i
              v-if="!previewMode && !isLastBranch(idx)"
              @click.stop="deleteNode(idx)"
              class="el-icon-error workflowNodeDel"
            ></i>
            <div class="workflowName workflowBranchItem">
              <span v-if="isLastBranch(idx)">
                不满足任何分支的数据进入该分支
              </span>
              <span v-else-if="!showPreview(idx)">所有数据可进入该分支</span>
              <template v-else>
                <div
                  v-for="(list, conditionBlockIndex) in branchInfo.extra.description[idx]"
                  :key="conditionBlockIndex"
                >
                  <div v-if="conditionBlockIndex != 0" class="tag-or">
                    <span>或</span>
                  </div>
                  <div v-for="(item, index) in list" :key="index" class="condition-row">
                    <span class="label">{{ item.key }}</span>

                    <span class="compare">
                      {{
                        item.compareMethod == "为空" && item.key == "审批结果"
                          ? "撤回"
                          : item.compareMethod
                      }}
                    </span>
                    <span v-tip class="value">{{ item.value }}</span>
                  </div>
                </div>
              </template>
            </div>
            <div class="workflowContent">
              <div class="text">设置筛选条件</div>
            </div>
          </div>
          <div class="workflowLineBtn">
            <div v-if="!previewMode" class="icon-add" @click="openInsertNode(idx)">
              <i class="el-icon-circle-plus-outline"></i>
            </div>
          </div>
        </section>
        <div v-for="(item, index) in branch" :key="index">
          <workBranchItem v-if="item.type == 'Gateway'" :branchInfo="item"></workBranchItem>
          <WorkflowItem v-else :workFlow="item"></WorkflowItem>
        </div>
      </div>
    </section>
    <div class="workflowLineBtn">
      <div v-if="!previewMode" class="icon-add" @click="openInsertNode(null)">
        <i class="el-icon-circle-plus-outline"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../eventBus"
import WorkflowItem from "./workflowItem"

export default {
  name: "workBranchItem",
  components: {
    WorkflowItem
  },
  props: {
    branchInfo: Object
  },
  inject: ["workflowType", "previewMode"],
  methods: {
    setWorkFlow(idx) {
      if (this.isLastBranch(idx)) return
      EventBus.$emit("openSetting", {
        workFlow: this.branchInfo,
        branchIndex: idx
      })
    },
    openInsertNode(idx) {
      EventBus.$emit("openInsertNode", {
        workFlow: this.branchInfo,
        branchIndex: idx
      })
    },
    deleteNode(idx) {
      EventBus.$emit("deleteNode", {
        workFlow: this.branchInfo,
        branchIndex: idx
      })
    },
    showPreview(idx) {
      return this.branchInfo.extra?.description?.[idx]?.length
    },
    addBranch() {
      let branchCount = this.branchInfo.children.length
      this.branchInfo.children.splice(branchCount - 1, 0, [])
      this.branchInfo.nexts.splice(branchCount - 1, 0, this.branchInfo.id + "_close")
      this.branchInfo.data.nextFilters.splice(branchCount - 1, 0, [])
      EventBus.$emit("updateFlowNode", {
        nodeInfo: this.branchInfo
      })
    },
    isLastBranch(idx) {
      return idx === this.branchInfo?.children.length - 1
    }
  }
}
</script>

<style lang="scss" scoped>
.workflowColumn {
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: column;
  font-size: 13px;
  flex: 1 1;
  .workflowLineBtn {
    padding: 20px 0;
    width: 280px;
    position: relative;
    .icon-add {
      width: 24px;
      height: 20px;
      display: block;
      font-size: 24px;
      line-height: 22px;
      cursor: pointer;
      position: relative;
      background: #f5f5f5;
      color: #ccc;
      margin: 0 auto;
      &:hover {
        color: #757575;
      }
      i {
        margin-top: -2px;
      }
    }
  }
  > .workflowLineBtn {
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 1px;
      height: 100%;
      background-color: #ccc;
    }
  }
  .workflowBranch {
    display: inline-flex;
    position: relative;
    padding-top: 13px;
    background-color: #f5f5f5;
    .workflowBranchBtn {
      font-size: 26px;
      position: absolute;
      top: 0;
      left: 50%;
      z-index: 3;
      width: 26px;
      height: 26px;
      cursor: pointer;
      margin-left: -13px;
      background: #f5f5f5;
      color: #2196f3;
      &:hover {
        color: #1565c0;
      }
      i {
        margin-top: -1px;
        vertical-align: super;
      }
    }
    .fill-Empty {
      position: absolute;
      top: 0;
      left: 50%;
      z-index: 3;
      width: 26px;
      height: 26px;
      margin-left: -13px;
      &::before {
        content: "";
        position: absolute;
        height: 50%;
        left: 50%;
        width: 1px;
        background-color: #ccc;
      }
    }
    .branchItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 1px;
        height: 100%;
        background-color: #ccc;
      }
      &.last-branch {
        .workflowItem {
          cursor: default !important;
          .workflowContent .text {
            color: #999 !important;
          }
        }
      }
      .workflowBox {
        padding: 40px 50px 0;
        position: relative;
        box-sizing: border-box;

        .workflowItem {
          width: 280px;
          background: #fff;
          border-radius: 6px;
          position: relative;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
          display: flex;
          flex-direction: column;
          cursor: pointer;
          &:hover {
            .workflowNodeDel {
              display: inline-block;
            }
          }
          .workflowNodeDel {
            color: #757575;
            cursor: pointer;
            position: absolute;
            top: -8px;
            right: -10px;
            font-size: 22px;
            width: 22px;
            height: 22px;
            background: #fff;
            border-radius: 50%;
            display: none;
            z-index: 10;
            &:hover {
              color: #f44336;
            }
          }
          .workflowName {
            width: 100%;
            position: relative;
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
            padding: 26px 10px 0;
            box-sizing: border-box;
          }
          .workflowBranchItem {
            font-size: 13px;
            border-bottom: 1px solid #ccc;
            padding: 8px;
            min-height: 50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: #333;
            height: auto;
            text-align: left;
            .tag-or {
              margin: 6px 0;
              position: relative;
              text-align: center;
              &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 0;
                right: 0;
                border-bottom: 1px solid #bdbdbd;
              }
              span {
                display: inline-block;
                padding: 0 10px;
                background: #fff;
                position: relative;
              }
            }
            .condition-row {
              display: flex;
              line-height: 32px;
              background: #f5f5f5;
              padding: 0 8px;
              .label {
                flex-shrink: 0;
              }
              .compare {
                flex-shrink: 0;
                margin: 0 6px;
                color: #888;
              }
            }
          }
          .flexRow {
            display: flex;
            height: 32px;
            line-height: 32px;
            background: #f5f5f5;
            padding: 0 8px;
            .maxWidth60 {
              max-width: 60px;
            }
            .flex {
              flex: 1 1;
            }
          }
          .workflowContent {
            padding: 8px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            min-height: 34px;
            .text {
              padding-left: 8px;
              color: #2196f3;
            }
          }
        }
      }
      .clearLeftBorder {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: -4px;
          width: 50%;
          background: #f5f5f5;
          height: 6px;
        }
        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -5px;
          width: 50%;
          background: #f5f5f5;
          height: 6px;
        }
      }
      .clearRightBorder {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        &::before {
          content: "";
          position: absolute;
          right: 0px;
          top: -5px;
          width: 50%;
          background: #f5f5f5;
          height: 6px;
        }
        &::after {
          content: "";
          position: absolute;
          right: -0.5px;
          bottom: -5px;
          width: 50%;
          background: #f5f5f5;
          height: 6px;
        }
      }
    }
  }
}
</style>
